const SINGLETON = 'SINGLETON';
const TRANSIENT = 'TRANSIENT';
const SCOPED = 'SCOPED';

export default {
  SINGLETON,
  TRANSIENT,
  SCOPED,
};



// WEBPACK FOOTER //
// ./core/dependency-container/constants/Lifetime.ts